<template>
    <Button label="Novo Parâmetro" icon="pi pi-plus" @click="toInserir()" v-if="$temAcessoView('PARAM-01')" />
</template>

<script>
export default {
    methods: {
        toInserir() {
            this.$router.push({
                name: 'Parametros_Inserir',
            });
        },
    },
};
</script>
